import { Accordion, AccordionItemButton, AccordionItemHeading, AccordionItemPanel, AccordionItemState } from 'react-accessible-accordion'
import { CategoriesWithoutChild, CategoryAccordionItem } from '../styles'
import { ReactComponent as ExpandedOff } from 'assets/images/icons/expander_off.svg'
import { ReactComponent as ExpandedOn } from 'assets/images/icons/expander_on.svg'
import { ReactComponent as CategoryClosedIcon } from 'assets/images/icons/category closed.svg'
import { ReactComponent as CategoryOpenedIcon } from 'assets/images/icons/category opend.svg'
import { ReactComponent as SelectedIcon } from 'assets/images/icons/selected.svg'
import { ReactComponent as PrivateIcon } from 'assets/images/icons/private.svg'
import { checkUser_for_admin_or_owner_or_editor, RESTRICTED_CATEGORY_NAMES, usePrevious } from 'utils/helpers'
import { FormGroup, Input } from 'reactstrap'
import { CustomButton } from 'modules/auth/styles'
import { Fragment, useEffect, useState } from 'react'
import { ButtonLoader } from 'utils/storageUtils'

export function CategoriesSelector(props) {
  const { private_categories, shared_categories, preExpandedCategory, category, user, isExport } = props
  const [is_submitting, set_is_submitting] = useState(false)

  const [newCategoryName, set_newCategoryName] = useState('')
  const [hasError, set_hasError] = useState(false)

  const [allCategories, set_allCategories] = useState([...private_categories, ...shared_categories])
  const [state_preExpandedCategory, set_state_preExpandedCategory] = useState(preExpandedCategory)
  const [searchText, set_searchText] = useState('')
  const prev_searchText = usePrevious(searchText)

  useEffect(() => {
    if (prev_searchText !== searchText) {
      if (searchText.trim() !== '') {
        const _allCategories = []
        for (const cat of allCategories) {
          const _cat = { ...cat, subcategories: [] }
          for (const sub_cat of cat.subcategories) {
            const _sub_cat = { ...sub_cat, subcategories: [] }
            for (const sub_sub_cat of sub_cat.subcategories) {
              const _sub_sub_cat = { ...sub_sub_cat, subcategories: [] }
              if (_sub_sub_cat.name.toLowerCase().includes(searchText.toLocaleLowerCase())) {
                _sub_cat.subcategories.push(_sub_sub_cat)
              }
            }
            if (_sub_cat.name.toLowerCase().includes(searchText.toLocaleLowerCase()) || _sub_cat.subcategories.length > 0) {
              _cat.subcategories.push(sub_cat)
            }
          }

          if (_cat.name.toLowerCase().includes(searchText.toLocaleLowerCase()) || _cat.subcategories.length > 0) {
            _allCategories.push(_cat)
          }
        }

        const _preExpanded = []
        for (const cat of _allCategories) {
          _preExpanded.push(`cat_${cat.id}`)
          for (const sub_cat of cat['subcategories']) {
            _preExpanded.push(`cat_${sub_cat.id}`)
          }
        }
        set_state_preExpandedCategory(_preExpanded)
        set_allCategories(_allCategories)
      } else {
        set_allCategories([...private_categories, ...shared_categories])
        set_state_preExpandedCategory(preExpandedCategory)
      }
    }
  }, [searchText, prev_searchText, private_categories, shared_categories, preExpandedCategory, allCategories])

  const onSubmitNewCategory = async () => {
    try {
      if (!newCategoryName.trim()) {
        set_hasError('Required')
        return
      }
      set_is_submitting(true)
      const data = { name: newCategoryName, type: props.type }
      const create_result = await props.saveCategory(data)
      props.selectCategory(create_result)
      props.getCategories()
      set_newCategoryName('')
    } catch (error) {}
    set_is_submitting(false)
  }

  return (
    <div className='p-3 CategoriesAccordion'>
      {/* Categories without subcategories */}
      <div className={props.showNewCategoryForm ? 'mb-3' : ''}>
        {/* Search Text */}
        <FormGroup>
          <Input autoFocus name='searchText' value={searchText} placeholder='Search category' onChange={(e) => set_searchText(e.target.value)} />
        </FormGroup>
        {!searchText && (
          <CategoriesWithoutChild addMargin={false}>
            <li className={`${(isExport && category?.id === 'private') || (!isExport && (!category || !category.id)) ? 'active' : ''}`} onClick={(e) => e.stopPropagation()}>
              <a
                href='/'
                className={`categoryName px-2 ${(isExport && category?.id === 'private') || (!isExport && (!category || !category.id)) ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  props.selectCategory(isExport ? { id: 'private', uuid: 'private' } : {})
                }}>
                <PrivateIcon />
                <span className='ml-2'>Private</span>
              </a>
              {((isExport && category?.id === 'private') || (!isExport && !category.id)) && (
                <span className='ml-auto d-flex mr-3'>
                  <SelectedIcon />
                </span>
              )}
            </li>
          </CategoriesWithoutChild>
        )}

        {/* Categories and subcategories */}
        <Accordion allowMultipleExpanded allowZeroExpanded preExpanded={state_preExpandedCategory}>
          {allCategories
            .filter((cat) => cat.subcategories.length > 0 && checkUser_for_admin_or_owner_or_editor(cat, user))
            .map((cat) => (
              <Fragment key={cat.id}>
                {(!searchText || (searchText && state_preExpandedCategory.includes(`cat_${cat.id}`))) && (
                  <CategoryAccordionItem key={cat.id} level={1} uuid={`cat_${cat.id}`}>
                    <AccordionItemHeading className='accordionItemHeading categorySection'>
                      <AccordionItemButton className='accordionItemButton'>
                        <AccordionItemState>
                          {({ expanded }) =>
                            expanded ? (
                              <div className='expandButton expanded'>
                                <ExpandedOn />
                              </div>
                            ) : (
                              <div className='expandButton'>
                                <ExpandedOff />
                              </div>
                            )
                          }
                        </AccordionItemState>
                        <a
                          href='/'
                          className={`categoryName px-1 mx-1 ${cat.id === category.id ? 'active' : ''}`}
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            props.selectCategory(cat)
                          }}>
                          {cat.shared_users && cat.shared_users.length > 0 && <AccordionItemState>{({ expanded }) => (expanded ? <CategoryOpenedIcon /> : <CategoryClosedIcon />)}</AccordionItemState>}
                          {(!cat.shared_users || cat.shared_users.length === 0) && <PrivateIcon />}
                          <span className='ml-2'>{cat.name}</span>
                        </a>
                        {cat.id === category.id && (
                          <span className='ml-auto d-flex mr-3'>
                            <SelectedIcon />
                          </span>
                        )}
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel className='AccordionItemPanel'>
                      {/* Level 2: Subcategories and Sub-sub categoreis */}
                      {cat.subcategories
                        .filter((sub_cat) => sub_cat.subcategories.length > 0)
                        .map((sub_cat) => (
                          <CategoryAccordionItem key={sub_cat.id} level={2} uuid={`cat_${sub_cat.id}`}>
                            <AccordionItemHeading className='accordionItemHeading categorySection'>
                              <AccordionItemButton className='accordionItemButton'>
                                <AccordionItemState>
                                  {({ expanded }) =>
                                    expanded ? (
                                      <div className='expandButton expanded'>
                                        <ExpandedOn />
                                      </div>
                                    ) : (
                                      <div className='expandButton'>
                                        <ExpandedOff />
                                      </div>
                                    )
                                  }
                                </AccordionItemState>
                                <a
                                  href='/'
                                  className={`categoryName px-1 mx-1 ${sub_cat.id === category.id ? 'active' : ''}`}
                                  onClick={(e) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    props.selectCategory(sub_cat)
                                  }}>
                                  <AccordionItemState>{({ expanded }) => (expanded ? <CategoryOpenedIcon /> : <CategoryClosedIcon />)}</AccordionItemState>
                                  <span className='ml-2'>{sub_cat.name}</span>
                                </a>
                                {sub_cat.id === category.id && (
                                  <span className='ml-auto d-flex mr-3'>
                                    <SelectedIcon />
                                  </span>
                                )}
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel className='AccordionItemPanel'>
                              <CategoriesWithoutChild addMargin={true}>
                                {sub_cat.subcategories.map((sub_sub_cat) => (
                                  <li key={sub_sub_cat.id} onClick={(e) => e.stopPropagation()}>
                                    <a
                                      href='/'
                                      className={`categoryName px-1 mx-1 ${sub_sub_cat.id === category.id ? 'active' : ''}`}
                                      onClick={(e) => {
                                        e.preventDefault()
                                        e.stopPropagation()
                                        props.selectCategory(sub_sub_cat)
                                      }}>
                                      <CategoryClosedIcon />
                                      <span className='ml-2'>{sub_sub_cat.name}</span>
                                    </a>
                                    {sub_sub_cat.id === category.id && (
                                      <span className='ml-auto d-flex mr-3'>
                                        <SelectedIcon />
                                      </span>
                                    )}
                                  </li>
                                ))}
                              </CategoriesWithoutChild>
                            </AccordionItemPanel>
                          </CategoryAccordionItem>
                        ))}

                      {/* Level 2: Subcategories without Sub-sub categoreis */}
                      <CategoriesWithoutChild addMargin={true}>
                        {cat.subcategories
                          .filter((sub_cat) => sub_cat.subcategories.length === 0)
                          .map((sub_cat) => (
                            <li key={sub_cat.id} onClick={(e) => e.stopPropagation()}>
                              <a
                                href='/'
                                className={`categoryName px-1 mx-1 ${sub_cat.id === category.id ? 'active' : ''}`}
                                onClick={(e) => {
                                  e.preventDefault()
                                  e.stopPropagation()
                                  props.selectCategory(sub_cat)
                                }}>
                                <CategoryClosedIcon />
                                <span className='ml-2'>{sub_cat.name}</span>
                              </a>
                              {sub_cat.id === category.id && (
                                <span className='ml-auto d-flex mr-3'>
                                  <SelectedIcon />
                                </span>
                              )}
                            </li>
                          ))}
                      </CategoriesWithoutChild>
                    </AccordionItemPanel>
                  </CategoryAccordionItem>
                )}
              </Fragment>
            ))}
        </Accordion>

        {/* Categories without subcategories */}
        <CategoriesWithoutChild addMargin={false}>
          {allCategories
            .filter((cat) => cat.subcategories.length === 0 && checkUser_for_admin_or_owner_or_editor(cat, user))
            .map((cat) => (
              <li key={cat.id} onClick={(e) => e.stopPropagation()}>
                <a
                  href='/'
                  className={`categoryName px-1 mx-1 ${cat.id === category.id ? 'active' : ''}`}
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    props.selectCategory(cat)
                  }}>
                  {cat.shared_users && cat.shared_users.length > 0 && <CategoryClosedIcon />}
                  {(!cat.shared_users || cat.shared_users.length === 0) && <PrivateIcon />}
                  <span className='ml-2'>{cat.name}</span>
                </a>
                {cat.id === category.id && (
                  <span className='ml-auto d-flex mr-3'>
                    <SelectedIcon />
                  </span>
                )}
              </li>
            ))}
        </CategoriesWithoutChild>
      </div>
      {props.showNewCategoryForm && (
        <>
          <div className='text-center'>-or-</div>

          <div className='px-2 py-3'>
            <div className='d-flex align-items-center'>
              <Input
                name='name'
                placeholder='New category name'
                value={newCategoryName}
                onChange={(e) => {
                  set_hasError(false)
                  set_newCategoryName(e.target.value)
                  if (RESTRICTED_CATEGORY_NAMES.indexOf(e.target.value.trim().toLowerCase()) !== -1) {
                    set_hasError(`Choose category name other than "${RESTRICTED_CATEGORY_NAMES.join().replaceAll(`,`, `", "`)}"`)
                  }
                }}
                className={hasError ? 'error' : ''}
              />
              <CustomButton type='button' className='black btn-sm' disabled={!newCategoryName || is_submitting || hasError} onClick={onSubmitNewCategory}>
                Create {is_submitting && <ButtonLoader />}
              </CustomButton>
            </div>
            {hasError && <div className='error-message w-100'> {hasError} </div>}
          </div>
        </>
      )}
    </div>
  )
}
